export const compensate_work_header_table = [
  { label: 'Status', value: 0 },
  { label: 'Start Date', value: 1 },
  { label: 'End Date', value: 2 },
  { label: 'Days', value: 3 },
  { label: 'Employee ID', value: 4 },
  { label: 'Employee Name', value: 5 },
  { label: 'Project', value: 6 },
  { label: 'Approver', value: 7 },
]

export const subconstract_cost_header_table = [
  { label: 'Status', value: 7 },
  { label: 'Employee ID', value: 0 },
  { label: 'Employee Name', value: 1 },
  { label: 'Period', value: 2 },
  { label: 'Project', value: 3 },
  { label: 'Days', value: 4 },
  { label: 'Cost per Day (Baht)', value: 5 },
  { label: 'Total Cost (Baht)', value: 6 },
]

export const leave_history_report_table_header = [
  { label: 'Status', value: 8 },
  { label: 'Start Date', value: 0 },
  { label: 'End Date', value: 1 },
  { label: 'Days', value: 2 },
  { label: 'Leave Type', value: 3 },
  { label: 'Emp ID', value: 4 },
  { label: 'Emp Name', value: 5 },
  { label: 'Company', value: 6 },
  { label: 'LOB', value: 7 },
]



// WEBPACK FOOTER //
// ./src/components/report/constants.js